import { bindLargestSideVar } from '../lib/bindLargestSideVar';
import externalCss from '../../styles/ai-report2.scss?url';

function loadAiReportIframe(iframeEl) {
  if (
    !iframeEl ||
    iframeEl.tagName !== 'IFRAME' ||
    iframeEl.hasAttribute('src')
  )
    return;

  const { src: baseSrc } = iframeEl.dataset;
  if (!baseSrc) return;

  let finalUrl = baseSrc;

  if (externalCss) {
    // Make externalCss absolute using current origin if it lacks a domain
    const resolvedCss = new URL(
      externalCss.trim(),
      window.location.origin,
    ).toString();

    const url = new URL(baseSrc, window.location.href);
    url.searchParams.set('externalStylesheet', resolvedCss);
    finalUrl = url.toString();
  }

  iframeEl.setAttribute('src', finalUrl);
}

export function initAiReport(parent) {
  if (!parent) return;

  const report = parent.querySelector('.ai-report__report');
  bindLargestSideVar(report);

  const iframe = report.querySelector('.ai-report__iframe');
  loadAiReportIframe(iframe);
}

export function initAiReports() {
  const blocks = document.querySelectorAll('.ai-report');
  blocks.forEach((block) => initAiReport(block));
}
